<template>
  <section>
    <b-modal :active.sync="shouldShowFile">
      <p class="image">
        <img :src="imageSrc">
      </p>
    </b-modal>

    <button
      class="button is-info"
      @click="showFile">
      {{btnViewText}}
    </button>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ApiUtil from '@/utils/ApiUtil';


export default {
  props: {
    s3UploadKey: {
      type: String,
      required: false,
      default: '',
    },
    userId: {
      type: String,
      default: null,
    },
    btnViewText: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      imageSrc: null,
      shouldShowFile: false,
    };
  },
  computed: {
    ...mapState([
      'isLoading',
    ]),
  },
  methods: {
    ...mapMutations([
      'setIsLoading',
    ]),
    async showFile() {
      this.setIsLoading(true);
      this.imageSrc = await ApiUtil.getPresignedUrl({
        s3UploadKey: this.s3UploadKey,
        method: 'get',
        userId: this.userId,
      });
      this.shouldShowFile = true;
      this.setIsLoading(false);
    },
  },
};
</script>
